import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
   {
      path: '/',
      name: 'Login',
      component: () => import('../views/Login.vue')
   },
   {
      path: '/paginaInicial',
      name: 'Página_inicial',
      component: () => import('../views/PaginaInicial.vue')
   },
   {
      path: '/adicionar',
      name: 'Adicionar',
      component: () => import('../views/pages/Adicionar.vue')
   },
   {
      path: '/cadastros',
      name: 'Cadastros',
      component: () => import('../views/pages/Cadastros.vue')
   },
   {
      path: '/criarperguntas',
      name: 'CriarPerguntas',
      component: () => import('../views/pages/CriarPerguntas.vue')
   },
   {
      path: '/editarperguntas',
      name: 'EditarPerguntas',
      component: () => import('../views/pages/EditarPerguntas.vue')
   },
   {
      path: '/gerarlogin',
      name: 'GerarLogin',
      component: () => import('../views/pages/GerarLogin.vue')
   },
   {
      path: '/logins',
      name: 'Logins',
      component: () => import('../views/pages/Logins.vue')
   },
   {
      path: '/agenda',
      name: 'Agenda',
      component: () => import('../views/pages/Agenda.vue')
   },
   {
      path: '/relatorio',
      name: 'Relatorio',
      component: () => import('../views/pages/Relatorio.vue')
   },
   {
      path: '/adicionarEscola',
      name: 'AdicionarEscola',
      component: () => import('../views/pages/AdicionarEscola.vue')
   },
   {
      path: '/editarEscola',
      name: 'EditarEscola',
      component: () => import('../views/pages/EditarEscola.vue')
   },
   {
      path: '/escolas',
      name: 'Escolas',
      component: () => import('../views/Escolas.vue')
   },
]

const router = new VueRouter({
   mode: 'abstract',
   base: process.env.BASE_URL,
   routes
})

export default router
